var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tops"},[_c('div',{staticClass:"tops__body"},[_c('Tops',{attrs:{"id":"Tops","await-for-season":"","season":_vm.numberSeasonId,"is-cup":_vm.isCup,"show-logos":false,"custom":_vm.custom}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }